/**
 * Ambiente DEV (us-east-2) — usado pelo `ng serve` (local) e pelo `build:dev`
 * (deploy hospedado de dev). O build de produção substitui este arquivo por
 * `environment.prod.ts` (fileReplacements no angular.json).
 *
 * `apiUrl` é a base do API Gateway (o interceptor anexa o access token às
 * chamadas que começam com ela). `cognito` alimenta o `amplify.config.ts`.
 */
export const environment = {
  production: false,
  apiUrl: 'https://o9myjpc156.execute-api.us-east-2.amazonaws.com/staging',
  cognito: {
    userPoolId: 'us-east-2_IxibTynj3',
    userPoolClientId: '1s93v75dv8lr9u7khiu9lc5dsk',
    domain: 'unblockit-auth-staging.auth.us-east-2.amazoncognito.com',
    // DEV inclui localhost (para o `ng serve`) + o CloudFront de dev.
    redirectSignIn: [
      'http://localhost:4200/callback',
      'https://dtr1rvawivyf.cloudfront.net/callback',
      'https://app-dev.unblockit.com.br/callback',
    ],
    redirectSignOut: [
      'http://localhost:4200/logout',
      'https://dtr1rvawivyf.cloudfront.net/logout',
      'https://app-dev.unblockit.com.br/logout',
    ],
  },
};
